module.exports = __webpack_public_path__ + "components/flag/static/square/gw-be7d9fe1902e4bcb7dd511930cdb7a64.svg";